"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/es6.regexp.replace");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = withWhereaboutsFilter;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

require("core-js/modules/es6.regexp.split");

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _utils = require("./utils");

var _withFilter = _interopRequireDefault(require("./with-filter"));

var _lodash = _interopRequireDefault(require("lodash"));

var _whereabouts = require("@rexlabs/whereabouts");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(source).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var SORTING_SEPARATOR = '|';
var URL_SEPARATOR = '.';

function withWhereaboutsFilter(filterConfig, customNamespace, opts) {
  var _sortingSeparator$url = _objectSpread({
    sortingSeparator: SORTING_SEPARATOR,
    urlSeparator: URL_SEPARATOR
  }, opts),
      sortingSeparator = _sortingSeparator$url.sortingSeparator,
      urlSeparator = _sortingSeparator$url.urlSeparator;

  return (0, _withFilter.default)(filterConfig, customNamespace, _objectSpread({}, opts, {
    setSorting: function setSorting(_ref) {
      var whereabouts = _ref.whereabouts;
      return function (namespace, sorting) {
        var query = _objectSpread({}, whereabouts.query);

        var urlString;
        var name;

        _lodash.default.forEach(sorting, function (value, key) {
          name = "".concat(namespace).concat(urlSeparator).concat(key);
          urlString = (0, _utils.generateUrlString)(_lodash.default.get(whereabouts, ['query', name], '').split(sortingSeparator)[0], value, sortingSeparator);

          if (urlString) {
            query[name] = urlString;
          } else {
            query = _lodash.default.omit(query, name);
          }
        });

        (0, _whereabouts.replace)({
          config: {
            path: whereabouts.path,
            query: query
          }
        });
        return (0, _utils.getObjectFromQuery)(query, namespace, sortingSeparator, urlSeparator);
      };
    },
    setFilters: function setFilters(_ref2) {
      var whereabouts = _ref2.whereabouts;
      return function (namespace, filters) {
        var query = _objectSpread({}, whereabouts.query);

        var urlString;
        var name;

        _lodash.default.forEach(filters, function (value, key) {
          name = "".concat(namespace).concat(urlSeparator).concat(key);

          var existingQuery = _lodash.default.get(whereabouts, ['query', name], '');

          urlString = (0, _utils.generateUrlString)(value, existingQuery.split(sortingSeparator)[1], sortingSeparator);

          if (urlString) {
            query[name] = urlString;
          } else {
            query = _lodash.default.omit(query, name);
          }
        });

        (0, _whereabouts.replace)({
          config: {
            path: whereabouts.path,
            query: query
          }
        });
        return (0, _utils.getObjectFromQuery)(query, namespace, sortingSeparator, urlSeparator);
      };
    },
    sortingValues: function sortingValues(namespace, _ref3) {
      var whereabouts = _ref3.whereabouts;
      return (0, _utils.getObjectFromQuery)(whereabouts.query, namespace, sortingSeparator, urlSeparator).sorting;
    },
    filterValues: function filterValues(namespace, _ref4) {
      var whereabouts = _ref4.whereabouts;
      return (0, _utils.getObjectFromQuery)(whereabouts.query, namespace, sortingSeparator, urlSeparator).filters;
    }
  }));
}